export default {

    AboutUs: {
        "companyProfile": "公司简介",
        "contactAddress": "联系地址"
    },
    DownLoadUs: {
        "serviceAndSupport": "服务与支持"
    },
    Dynamic: {
      "theDevelopmentOfLangState": "朗国动态"
    }

}



// WEBPACK FOOTER //
// ./src/i18n/zh/index.zh.js